import { appEventTypes } from "@src/common/events/AppEventTarget";

class ConnectorStatusEvent extends CustomEvent<null> {
  constructor() {
    super(appEventTypes.CONNECTOR_STATUS_CHANGE);
  }
}

export default ConnectorStatusEvent;
